import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

// Components
import { Text, FormField, Format } from '../../../..'
import DollarInput from '../../../Input/DollarInput'

// Styles
import styles from './LoanBalance.module.scss'

const propTypes = {
  loanId: PropTypes.string,
  date: PropTypes.string,
  termYears: PropTypes.num,
  termYearsEstimated: PropTypes.num,
  amount: PropTypes.num,
  principalLeft: PropTypes.num,
}

const LoanBalance = ({
  loanId,
  principalLeft,
  amount,
  date,
  termYears,
  termYearsEstimated,
}) => {
  const loanTerm = termYears || termYearsEstimated

  return (
    <>
      <Text
        align='left'
        variant='neutralCool'
        variantCount='900'
        className={styles.loanBalanceText}
      >
        <FormattedMessage
          id='Homeowner.interest.paidExtra.loanInfo'
          defaultMessage='{loanTerm}-year loan for {loanAmount} from {loanDate}'
          values={{
            loanTerm,
            loanAmount: <Format.Currency abbreviate value={amount} />,
            loanDate: <Format.Date value={date} format='MMM YYYY' />,
          }}
        />
      </Text>
      <FormField.Dollars
        name={loanId}
        required
        conditions={[DollarInput.maxCondition(amount)]}
        defaultValue={Math.round(principalLeft)}
      >
        <FormattedMessage
          id='Homeowner.interest.paidExtra.inputLabel'
          defaultMessage="Today's Balance"
        />
      </FormField.Dollars>
      <Text align='left' size='xxs' variant='neutralCool' variantCount='600'>
        <FormattedMessage
          id='Homeowner.interest.paidExtra.AmountPaid'
          defaultMessage='Assuming you’ve paid this month’s bill'
        />
      </Text>
    </>
  )
}

LoanBalance.propTypes = propTypes

export default LoanBalance
